module.exports = __webpack_public_path__ + "img/gallery11.b2d426c0.jpg";